import CookiePreferencesLink from "@/app/components/legal/CookiePreferencesLink";
import type { Route } from "next";
import Link from "next/link";
import {
  getH2SubjectRoutes,
  isH2StudySubject,
  type H2StudySubject,
} from "@/lib/study/h2-study-topics";

export default function StudyResourceFooter({
  subject,
}: {
  subject?: string | null;
}) {
  const resolvedSubject: H2StudySubject | null =
    subject && isH2StudySubject(subject) ? subject : null;
  const routes = resolvedSubject ? getH2SubjectRoutes(resolvedSubject) : null;

  return (
    <footer className="border-t border-slate-200 bg-slate-950 text-white">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-8 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="text-lg font-semibold">
            {routes
              ? `${routes.label} study resources`
              : "Eclat study resources"}
          </p>
          <p className="mt-2 max-w-xl text-sm leading-6 text-slate-300">
            Move between notes, short explanations, and practice without losing
            the topic you are studying.
          </p>
        </div>
        <nav aria-label="Study resource footer" className="text-sm">
          <ul className="flex flex-wrap gap-x-5 gap-y-3">
            {routes ? (
              <>
                <li>
                  <Link<string>
                    className="underline underline-offset-4"
                    href={routes.notesHubHref as Route}
                  >
                    Notes
                  </Link>
                </li>
                <li>
                  <Link<string>
                    className="underline underline-offset-4"
                    href={routes.quizHubHref as Route}
                  >
                    Quizzes
                  </Link>
                </li>
                <li>
                  <Link<string>
                    className="underline underline-offset-4"
                    href={routes.videoHubHref as Route}
                  >
                    Videos
                  </Link>
                </li>
              </>
            ) : null}
            <li>
              <Link className="underline underline-offset-4" href="/blog">
                All study resources
              </Link>
            </li>
            <li>
              <Link
                className="underline underline-offset-4"
                href="/legal/privacy"
              >
                Privacy
              </Link>
            </li>
            <li>
              <CookiePreferencesLink className="underline underline-offset-4" />
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
